import BaseModelAPI from '../BaseModelAPI';

export default class ApprovalConfigurationList extends BaseModelAPI {

	static entity = 'approvalconfigurationlist'
	static entityName = 'approvalconfiguration';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
